"use client"

import type React from "react"
import { useContext } from "react"
import { UserContext } from "./UserContextProvider"

export function Internal({ children }: { children: React.ReactNode }) {
  const { isInternal } = useContext(UserContext)
  if (!isInternal) {
    return null
  }
  return children
}

export function External({ children }: { children: React.ReactNode }) {
  const { isInternal } = useContext(UserContext)
  if (isInternal) {
    return null
  }
  return children
}
